export type SortType<T> = {
  // eslint-disable-next-line no-unused-vars
  [key in keyof T]: boolean;
};

// eslint-disable-next-line import/prefer-default-export
export const formatSort = <T>(sortOptions?: SortType<T>): string | undefined => {
  if (!sortOptions) { return undefined; }

  const sortedArray = Object.entries(sortOptions);
  return sortedArray.reduce((res, item, index) => (
    `${res}${item[1] === true ? '!' : ''}${item[0]}${index < sortedArray.length - 1 ? ',' : ''}`
  ), '');
};
